import { createReducer, on } from "@ngrx/store";

import { ProductActions } from './products.actions';

import { initialState, productsAdapter } from "./products.state";
import { LoadingState } from "@core/models";


export const productsReducer = createReducer(
  initialState,

  on(ProductActions.reset, (state) => ({ ...initialState })),

  on(ProductActions.add, (state, { command }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ProductActions.addSuccess, (state, { product }) => {
    return productsAdapter.upsertOne(product, { ...state, callState: LoadingState.LOADED });
  }),
  on(ProductActions.addFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(ProductActions.update, (state, { command }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ProductActions.updateSuccess, (state, { product }) => {
    return productsAdapter.upsertOne(product, { ...state, callState: LoadingState.LOADED });
  }),
  on(ProductActions.updateFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(ProductActions.remove, (state, { command }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ProductActions.removeSuccess, (state, { productCode }) => {
    const product = productsAdapter.getSelectors().selectAll(state).find(p => p.productCode === productCode);
    if (product) {
      return productsAdapter.removeOne(product.productCode, { ...state, callState: LoadingState.LOADED });
    }
    return { ...state, callState: LoadingState.LOADED };
  }),
  on(ProductActions.removeFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(ProductActions.load, (state) => ({
    ...state,
    // Only set LOADING on initial fetch so the list stays visible when refetching (merge behavior).
    callState: state.ids.length === 0 ? LoadingState.LOADING : state.callState,
  })),
  on(ProductActions.loadSuccess, (state, { products }) => {
    return productsAdapter.upsertMany(products, { ...state, callState: LoadingState.LOADED });
  }),
  on(ProductActions.loadFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),
);
